import styled from "styled-components";
import useBranchRegister from "features/owner/hooks/useBranchRegister";
import RequiredInputs from "./RequiredInputs";
import NormalInputs from "./NormalInputs";
import Modal from "shared/components/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import RegisterFooter from "shared/components/RegisterFooter";
import { hw, scrollbar } from "features/homework/homeworkUi";

const BranchRegister = () => {
    const navigate = useNavigate();
    const branch_id = useLocation().state;
    const { branchInputs, onBranchChange, onSaveButtonClick, 
        isError, setIsError, isSucceed, setIsDuplicated, 
        isOpenPasswordModal, setIsOpenPasswordModal,
        isOpenDuplicatedModal, setIsOpenDuplicatedModal,
        isOpenNullModal, setIsOpenNullModal,
        isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal,
        onDeleteClickHandler, reportPermission, onPermissionChangeHandler
    } = useBranchRegister();

    return(
        <Container>
            <Wrapper>
                <Header>
                    <div>
                        <Title>{branch_id ? "지점 수정" : "지점 등록"}</Title>
                        <Desc>{branch_id ? "선택한 지점 정보를 수정한 뒤 저장하세요." : "필수 항목을 입력한 뒤 지점 계정을 생성하세요."}</Desc>
                    </div>
                    <Close type="button" onClick={() => navigate("..")}>닫기</Close>
                </Header>
                <Content>
                    <Modal isOpen={isOpenPasswordModal} title="ERROR" content="패스워드가 일치하지 않습니다" onClose={() => setIsOpenPasswordModal(false)}/>
                    <Modal isOpen={isOpenDuplicatedModal} title="ERROR" content="아이디 중복확인을 해주세요" onClose={() => setIsOpenDuplicatedModal(false)}/>
                    <Modal isOpen={isOpenNullModal} title="ERROR" content="필수 입력란을 모두 입력해 주세요" onClose={() => setIsOpenNullModal(false)}/>
                    <Modal isOpen={isError} title="ERROR" content="계정생성중 오류가 발생하였습니다" onClose={() => setIsError(false)}/>
                    <Modal isOpen={isOpenDeleteSucceedModal} title="SUCCESS" content="삭제 되었습니다 새로고침을 눌러주세요" onClose={() => {setIsOpenDeleteSucceedModal(false); navigate(-1);}}/>
                    <Modal isOpen={isSucceed} title="SUCCESS" content={branch_id ? "수정되었습니다" : "계정이 생성되었습니다"} onClose={() => navigate("..")} />
                    <RequiredInputs branchInputs={branchInputs} onBranchChange={onBranchChange} setIsDuplicated={setIsDuplicated} reportPermission={reportPermission} onPermissionChange={onPermissionChangeHandler} />
                    <NormalInputs branchInputs={branchInputs} onBranchChange={onBranchChange}/>
                </Content>
                <RegisterFooter onSaveButtonClick={onSaveButtonClick} onDeleteButtonClick={branch_id ? onDeleteClickHandler : undefined}/>
            </Wrapper>
        </Container>
    )
}

const Container = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    padding: 20px 24px;
    z-index: 10;
    background: ${hw.bg};
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 22px 24px 16px;
    border-radius: 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    box-shadow: ${hw.shadow};
    flex: 1;
    min-height: 0;
    overflow: hidden;
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    flex-shrink: 0;
`

const Title = styled.h1`
    margin: 0;
    color: ${hw.text};
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.03em;
`

const Desc = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${hw.textMuted};
`

const Close = styled.button`
    appearance: none;
    border: 1px solid ${hw.border};
    background: ${hw.surface};
    color: ${hw.textMuted};
    font-size: 13px;
    font-weight: 600;
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;

    &:hover {
        background: ${hw.bg};
        color: ${hw.text};
    }
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    ${scrollbar}
`

export default BranchRegister;
